const ON_CHANGE_DEBOUNCE_TIMER = 300;
var requestId = 0;
const cartManager = {
  removeItem(cartItem, variantKey) {
    var newRequestId = new Date().getTime();
    requestId = newRequestId;
    collapse(cartItem).then(() => window.SuperTheme.updateQuantity(variantKey, 0, newRequestId));
  },
  fetchCart(e) {
    return new Promise((resolve, reject) => {
      fetch(`${window.Shopify.routes.root}?view=cart&timestamp=${new Date().getTime()}`)
        .then((resp) => resp.text())
        .then((cartData) => {
          if (!e.detail?.currentRequestId) {
            return resolve(cartData);
          }

          if (requestId === e.detail?.currentRequestId) {
            return resolve(cartData);
          }
        });
    });
  },
};

class DrawerHide extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      document.getElementById(this.getAttribute('drawer')).hide();
    });
  }
}
customElements.define('drawer-hide', DrawerHide);

class DrawerShow extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      if (typeof this.getAttribute('prevent-default') !== undefined) {
        event.preventDefault();
      }
      document.getElementById(this.getAttribute('drawer'))?.show();
    });
  }
}
customElements.define('drawer-show', DrawerShow);

class SlideDrawer extends HTMLElement {
  static observedAttributes = ['open'];

  constructor() {
    super();
    this.transitionDuration = 700;
    this.style.display = 'none';
    this.zendeskHidden = false;
  }

  connectedCallback() {
    if (this.className.includes('duration')) {
      this.transitionDuration = this.durationToMs(window.getComputedStyle(this).transitionDuration);
    }
  }

  hide() {
    this.open = false;
    this.removeBodyClass();
    let element = this;

    if (this.teleportedElement) {
      element = this.teleportedElement;
      element.removeAttribute('open');

      setTimeout(() => {
        if (this.teleportedElement) this.teleportedElement.remove();
        if (this.teleportedDrawerHideElement) this.teleportedDrawerHideElement.remove();
        element.style.display = 'none';
      }, this.transitionDuration);

      return;
    }

    element.removeAttribute('open');

    setTimeout(() => {
      element.style.display = 'none';
    }, this.transitionDuration);
  }

  show() {
    this.open = true;
    this.addBodyClass();
    const destination = this.getAttribute('teleport-destination');
    const inject = this.getAttribute('teleport-inject');
    let element = this;

    if (destination) {
      this.teleportedDrawerHideElement = document.createElement('drawer-hide');
      this.teleportedDrawerHideElement.setAttribute('drawer', this.id);
      this.teleportedDrawerHideElement.setAttribute('aria-controls', this.id);
      this.teleportedDrawerHideElement.classList.add('fixed', 'w-full', 'h-full', 'top-0', 'left-0');

      this.teleportedElement = this.cloneNode(true);
      this.teleportedElement.removeAttribute('teleport-destination');
      this.teleportedElement.removeAttribute('teleport-inject');
      this.teleportedElement.querySelectorAll('[clickable]').forEach((element) => {
        element.removeAttribute('clickable');

        const newAnchor = document.createElement('a');
        for (const attribute of element.attributes) {
          newAnchor.setAttribute(attribute.name, attribute.value);
        }

        while (element.firstChild) {
          newAnchor.appendChild(element.firstChild);
        }

        element.parentNode.replaceChild(newAnchor, element);
      });

      switch (inject) {
        case 'after':
          document
            .getElementById(destination)
            .parentNode.insertBefore(this.teleportedElement, document.getElementById(destination).nextSibling);
          break;
        case 'inside':
          document.getElementById(destination).append(this.teleportedElement);
          break;
      }

      this.teleportedElement.parentNode.insertBefore(
        this.teleportedDrawerHideElement,
        this.teleportedElement.previousSibling,
      );

      element = this.teleportedElement;
    }
    element.style.display = '';

    window.requestAnimationFrame(() => {
      element.setAttribute('open', '');
    });

    const cartItemAddBtns = element.querySelectorAll('cart-add-button');

    if (cartItemAddBtns.length > 0) {
      cartItemAddBtns.forEach((cartItemAddBtn) => {
        cartItemAddBtn.addEventListener('adding', () => {
          this.hide();
        });

        cartItemAddBtn.addEventListener('error', () => {
          this.show();
        });
      });
    }
  }

  durationToMs(duration) {
    if (typeof duration !== 'string') {
      throw new Error('Input must be a string');
    }

    duration = duration.trim();

    // Check if the value is in milliseconds
    if (duration.endsWith('ms')) {
      return parseFloat(duration.slice(0, -2));
    }

    // Check if the value is in seconds
    if (duration.endsWith('s')) {
      let seconds = parseFloat(duration.slice(0, -1));
      return seconds * 1000;
    }

    let milliseconds = parseFloat(duration);
    if (isNaN(milliseconds)) {
      throw new Error('Invalid transition-duration value');
    }
    return milliseconds;
  }

  addBodyClass() {
    if (window.routes.cart_url !== window.location.pathname) {
      enableScrollLock(this);
    }
    pauseVideosPlaying();
    this.toggleZendesk();
    this.toggleUserway();
  }

  removeBodyClass() {
    if (window.routes.cart_url !== window.location.pathname) {
      disableScrollLock(this);
    }
    continuePlayingVideos();
    this.toggleZendesk();
    this.toggleUserway();
  }

  toggleZendesk() {
    if (!document.querySelector('#launcher')) {
      return;
    }

    if (document.querySelector('#launcher').style.display === 'none' && this.zendeskHidden == false) {
      return;
    }

    if (this.open) {
      this.zendeskHidden = true;
      document.querySelector('#launcher').style.display = 'none';
    } else {
      this.zendeskHidden = false;
      document.querySelector('#launcher').style.display = 'block';
    }
  }

  toggleUserway() {
    if (document.querySelector('.uwy')) {
      if (document.querySelector('.uwy').style.display == 'none') {
        document.querySelector('.uwy').style.display = 'block';
      } else {
        document.querySelector('.uwy').style.display = 'none';
      }
    }
  }
}
customElements.define('slide-drawer', SlideDrawer);

class CartItems extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('cart-updated', (e) => this.updateCart(e));
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
          this.updateCart(new Event('cart-updated'));
        }
    });
  }

  connectedCallback() {
    this.updateCart(new Event('cart-updated'));
  }

  updateCart(e) {
    cartManager.fetchCart(e).then((cartData) => {
      this.querySelector('#cart_content').innerHTML = cartData;
      this.replaceScripts();

      let cartCount = document.querySelector('[data-cart-count]').getAttribute('data-cart-count');
      let cartBuble = document.querySelector('#cart_buble');
      cartBuble.innerHTML = cartCount;
      if (parseInt(cartCount) !== 0) cartBuble.classList.remove('hidden');
      if (parseInt(cartCount) === 0) cartBuble.classList.add('hidden');
    });
  }

  replaceScripts() {
    Array.from(this.querySelectorAll('#cart_content script[auto-inject]')).forEach((oldScriptEl) => {
      const newScriptEl = document.createElement('script');

      Array.from(oldScriptEl.attributes).forEach((attr) => {
        newScriptEl.setAttribute(attr.name, attr.value);
      });

      const scriptText = document.createTextNode(oldScriptEl.innerHTML);
      newScriptEl.appendChild(scriptText);

      oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
    });
  }
}
customElements.define('cart-items', CartItems);

class CartDrawer extends CartItems {
  constructor() {
    super();
    window.addEventListener('cart-drawer:open', () => !this.open && this.show());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.open) {
        this.hide();
      }
    });
  }

  addBodyClass() {
    enableScrollLock(this);
    document.querySelector('body').classList.add('cart-opened');
    pauseVideosPlaying();
    this.toggleZendesk();
    this.toggleUserway();
  }

  toggleZendesk() {
    if (!document.querySelector('#launcher')) {
      return;
    }

    if (this.open) {
      document.querySelector('#launcher').style.display = 'none';
    } else {
      document.querySelector('#launcher').style.display = 'block';
    }
  }

  toggleUserway() {
    if (document.querySelector('.uwy')) {
      if (document.querySelector('.uwy').style.display == 'none') {
        document.querySelector('.uwy').style.display = 'block';
      } else {
        document.querySelector('.uwy').style.display = 'none';
      }
    }
  }

  removeBodyClass() {
    disableScrollLock(this);
    document.querySelector('body').classList.remove('cart-opened');
    continuePlayingVideos();
    this.toggleZendesk();
    this.toggleUserway();
  }

  hide() {
    window.dispatchEvent(new CustomEvent('cartClosed'));
    this.open = false;
    this.classList.add('cartClosed');
    this.classList.remove('cartOpen');
    this.removeBodyClass();
    removeTrapFocus(document.querySelector('#slideCart'));
    document.querySelector('drawer-show[drawer="cart-drawer"] .btn-cart').focus();
  }

  show() {
    this.dispatchEvent(new CustomEvent('opening'));
    this.open = true;
    this.addBodyClass();
    this.classList.remove('cartClosed');
    this.classList.add('cartOpen');
    trapFocus(document.querySelector('#slideCart'));
    document.getElementById('cart-drawer-close').focus();
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartItem extends HTMLElement {
  constructor() {
    super();

    this.quantityInput = this.querySelector('quantity-input');
  }

  connectedCallback() {
    const debouncedOnChange = debounce((event) => {
      if (this.quantityInput.input.value === '0') {
        collapse(this).then(() => {
          window.SuperTheme.updateQuantity(event.target.dataset.variantKey, parseInt(event.target.value));
        });
        return;
      }
      window.SuperTheme.updateQuantity(event.target.dataset.variantKey, parseInt(event.target.value));
    }, ON_CHANGE_DEBOUNCE_TIMER);

    if (this.quantityInput) {
      this.quantityInput.addEventListener('change', debouncedOnChange);
    }
  }
}
customElements.define('cart-item', CartItem);

class CartItemCount extends HTMLElement {
  static observedAttributes = ['item-count'];

  constructor() {
    super();
    this.itemCountSlot = this.querySelector('slot[name="item-count"]');
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'item-count') {
      this.itemCountSlot.innerText = newValue;
    }
  }
}
customElements.define('cart-item-count', CartItemCount);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const variantKey = this.getAttribute('variant-key');
      const cartItem = document.getElementById(variantKey);
      cartManager.removeItem(cartItem, variantKey);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartAddButton extends HTMLElement {
  constructor() {
    super();
    this.cartElement =
      document.querySelector('cart-items #cart_content_wrapper') || document.querySelector('cart-drawer #slideCart');
    this.addEventListener('click', (event) => {
      if (typeof this.getAttribute('prevent-default') !== undefined) {
        event.preventDefault();
      }

      const variantId = this.getAttribute('variant-id');
      const properties = this.getAttribute('properties');
      let payload = {
        quantity: 1,
        id: variantId,
      };

      if (properties) {
        payload = {
          ...payload,
          properties: JSON.parse(properties.replaceAll("'", '"')),
        };
      }
      this.dispatchEvent(new CustomEvent('adding', { detail: { payload } }));

      fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((res) => {
              throw new Error(res?.description || window.cartStrings.addToCartError);
            });
          }

          return response.json();
        })
        .then((data) => {
          // fire javascript event on window
          window.dispatchEvent(new Event('cart-updated'));

          if (this.getAttribute('drawer') !== null) {
            window.dispatchEvent(new CustomEvent('cart-drawer:open'));
          }

          if (this.getAttribute('notify') !== null) {
            const toast = document.createElement('div');
            toast.className = 'toastify';
            toast.setAttribute('aria-live', 'polite');
            toast.innerHTML = `<span>${window.cartStrings.toastAddToCartSuccess.replace(
              '{{ product_title }}',
              data.product_title,
            )}`;

            this.cartElement.prepend(toast);
            setTimeout(() => {
              toast.remove();
            }, 1500);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          this.dispatchEvent(new CustomEvent('error', { detail: { message: error.message } }));
        });
    });
  }
}
customElements.define('cart-add-button', CartAddButton);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );
  }

  connectedCallback() {
    this.validateQtyRules();
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector("button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector("button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class RepScrollbar extends HTMLElement {
  constructor() {
    super();
    this.target = document.getElementById(this.dataset.targetId);
  }

  connectedCallback() {
    const stylesheet = new CSSStyleSheet();
    stylesheet.replaceSync(`
      :host .scrollbar-track {
        position: relative;
        width: 100%;
        height: 1px;
        background-color: #D9D9D9;
      }

      :host .scrollbar-thumb {
        position: absolute;
        top: 0;
        left: 0;
        height: 1px;
        background-color: #000000;
      }
    `);

    this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [stylesheet];

    this.shadowRoot.innerHTML += `
      <div class="scrollbar-track">
        <div class="scrollbar-thumb"></div>
      </div>
    `;

    this.scrollbarTrackEl = this.shadowRoot.querySelector('.scrollbar-track');
    this.scrollbarThumbEl = this.shadowRoot.querySelector('.scrollbar-thumb');
    this.trackWidth = this.scrollbarTrackEl.getBoundingClientRect().width;

    this.setScrollbarThumbWidth();
    this.attachListeners();

    const observer = new MutationObserver((mutations) => {
      const hasChildBeenAddedOrRemoved = mutations.find((mutation) => mutation.type === 'childList');
      if (hasChildBeenAddedOrRemoved) {
        this.setScrollbarThumbWidth();
      }
    });

    observer.observe(this.target, {
      childList: true,
      subtree: true,
    });

    this.target.addEventListener('scroll', () => {
      this.moveScrollbarThumb();
    });
  }

  moveScrollbarThumb() {
    const trackWidth = this.scrollbarTrackEl.getBoundingClientRect().width;
    const thumbWidth = (this.target.scrollLeft / this.target.scrollWidth) * trackWidth;
    this.scrollbarThumbEl.style.left = `${thumbWidth}px`;
  }

  setScrollbarThumbWidth() {
    const targetWidth = this.target.getBoundingClientRect().width;
    const scrollThumbWidth = Math.ceil((targetWidth / this.target.scrollWidth) * this.trackWidth);
    this.scrollbarThumbEl.style.width = `${scrollThumbWidth}px`;
  }

  attachListeners() {
    // attach click-drag event on the thumb
    let isDragging = false;
    let currentX;
    this.scrollbarThumbEl.addEventListener('mousedown', (e) => {
      isDragging = true;
      currentX = e.clientX;
      this.target.classList.add('prevent-scroll');
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;

      this.scrollbarTrackEl.style.position = '';
      this.scrollbarThumbEl.style.height = '';
      this.scrollbarThumbEl.style.transform = '';
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const deltaX = e.clientX - currentX;
      currentX = e.clientX;
      this.target.scrollLeft += deltaX * (this.target.scrollWidth / this.trackWidth);
    });

    this.scrollbarThumbEl.addEventListener('mouseenter', () => {
      this.scrollbarTrackEl.style.position = 'static';
      this.scrollbarThumbEl.style.height = '5px';
      this.scrollbarThumbEl.style.transform = 'translateY(-1.5px)';
    });

    this.scrollbarThumbEl.addEventListener('mouseleave', () => {
      if (isDragging) return;

      this.scrollbarTrackEl.style.position = '';
      this.scrollbarThumbEl.style.height = '';
      this.scrollbarThumbEl.style.transform = '';
    });
  }
}
customElements.define('rep-scrollbar', RepScrollbar);

class TagalysCartUpsell extends HTMLElement {
  constructor() {
    super();
    onTagalysReady(() => {
      Tagalys.APIConnector.Recommendations.call({
        params: {
          productId: this.getAttribute('product-ids'),
          recommendationId: this.getAttribute('widget-id'),
        },
        onSuccess: (response) => {
          const productIds = response.products.map((product) => product.id);

          if (productIds.length === 0) {
            return;
          }

          this.hydrateProductsWithSection(
            productIds,
            this.getAttribute('section-id'),
            this.getAttribute('selector'),
          ).then((html) => {
            this.innerHTML = html;
          });
        },
        onFailure: (response) => {
          document.getElementById('cart-upsell').style.display = 'none';
        },
      });
    });
  }

  hydrateProductsWithSection(productIds, sectionId, selector) {
    const productIdsAsQuery = productIds.map((productId) => `id:"${productId}"`);
    return new Promise((resolve, reject) => {
      fetch(
        `${window.Shopify.routes.root}search?q=${productIdsAsQuery.join(' OR ')}&section_id=${sectionId}&type=product`,
      )
        .then((res) => {
          if (!res.ok) {
            throw new Error('Failed to retrieve Tagalys products from Search API');
          }

          return res.text();
        })
        .then((res) => {
          const section = new DOMParser().parseFromString(res, 'text/html').querySelector(selector);
          return resolve(section.innerHTML);
        })
        .catch((err) => reject(err));
    });
  }
}
customElements.define('tagalys-cart-upsell', TagalysCartUpsell);

var bodyTopOrig = document.body.style.top;
var currentScrollPosition = 0;
var locks = [];

window.enableScrollLock = function (target) {
  const lock = {
    target,
  };
  locks = [...locks, lock];

  if (locks.length > 1) {
    // No need to apply lock if one already exists.
    return;
  }

  document.querySelector('html').classList.add('fn-noscroll');
};

window.disableScrollLock = function (target) {
  const hasLock = locks.filter((lock) => lock.target === target).length > 0;

  if (!hasLock) {
    return;
  }

  locks = locks.filter((lock) => lock.target !== target);

  if (locks.length > 0) {
    return;
  }

  document.querySelector('html').classList.remove('fn-noscroll');
};

var videosToContinuePlaying = [];

window.pauseVideosPlaying = function () {
  const videos = document.querySelectorAll('video');
  videos.forEach((video) => {
    if (window.isVideoPlaying(video)) {
      videosToContinuePlaying.push(video);
      video.pause();
    }
  });
};

window.continuePlayingVideos = function () {
  for (let i = 0; i < videosToContinuePlaying.length; i++) {
    videosToContinuePlaying[i].play();
  }

  videosToContinuePlaying = [];
};
